import http from "./HttpService";

const endpoint = `/user-management/`;
const headers = {};

export const getUsers = async ({ type, first, max, text = null, roleName = null }) => {
  let urlPath = `${endpoint}users/${type}?offset=${first}&limit=${max}`;
  if (text !== null && text !== undefined && text !== "") {
    urlPath += `&searchText=${text}`;
  }
  if (roleName !== null && roleName !== undefined && roleName !== "") {
    urlPath += `&role=${roleName}`;
  }

  const response = await http.get(urlPath);
  return response;
};

export const getRoles = async (serviceType) => {
  const response = await http.get(`${endpoint}roles/${serviceType}`, {
    headers: headers,
  });

  return response;
};

export const addUser = async (publicUser) => {
  
  const response = http.post(`${endpoint}register`,publicUser,
    { headers: headers }
  );
  return response;
};

export const registerUser = async (publicUser, serviceAcess) => {

  const response = await http.post(`${endpoint}public/register/${serviceAcess}`, publicUser,
    { headers: headers }
  );

  return response;
};

export const updateUserProfile = async (profileValues) => {

  const response = await http.patch(`${endpoint}update/profile`,profileValues,
    {
      headers: headers,
    }
  );
  return response;

};

export const updateUserPassword = async (password) => {

  const response = await http.patch(`${endpoint}update/password?password=${password}`,
    {
      headers: headers,
    }
  );
  return response;

};

export const updateUserDetails = async (values) => {
  const userId = values.id;

  const response = await http.put(`${endpoint}update/${userId}`, values,
    {
      headers: headers,
    }
  );
  return response;

};

export const updateUserAccess = async (accessValues, serviceType) => {

  const userId = accessValues.userId;
  const enabled = accessValues.enabled

  const response = await http.patch(`${endpoint}update/access/${serviceType}/${userId}/${enabled}`,
    {
      headers: headers,
    }
  );
  return response;

};

export const checkEmailExists = async (email) => {
  const response = await http.head(`${endpoint}users/email/${email}`, {
    headers: headers,
  });

  return response;
};

export const programmeSubscription = async (serviceName) => {
  const response = await http.post(`${endpoint}public/subscribe/${serviceName}?acceptedPrivacy=${true}`, {headers: headers});
  return response;
};

export const usersService = {
  getUsers,
  getRoles,
  addUser,
  checkEmailExists,
  updateUserProfile,
  updateUserDetails,
  updateUserAccess,
  updateUserPassword,
  registerUser,
  programmeSubscription,
};
